import { Box, Container, Loader, Paper, Title } from '@mantine/core';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import clientGuide from '../../../../../docs/guides/client.md?raw';
import managerGuide from '../../../../../docs/guides/manager.md?raw';
import adminGuide from '../../../../../docs/guides/admin.md?raw';
import { useAuthStore } from '../../shared/auth/auth.store';

/**
 * Отбрасываем YAML-frontmatter (между `---`) — он нужен только pandoc'у
 * при генерации .docx, в браузере это мусор.
 */
function stripFrontmatter(md: string): string {
  if (!md.startsWith('---')) return md;
  const end = md.indexOf('\n---', 3);
  if (end < 0) return md;
  return md.slice(end + 4).replace(/^\s*\n/, '');
}

const guidesByRole: Record<string, string> = {
  CLIENT: stripFrontmatter(clientGuide),
  MANAGER: stripFrontmatter(managerGuide),
  AUDITOR: stripFrontmatter(managerGuide),
  ADMIN: stripFrontmatter(adminGuide),
};

export function GuidePage() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Loader />;

  const md = guidesByRole[user.role] ?? '';

  return (
    <Container size="md" py="md">
      <Paper withBorder p="xl" radius="md">
        <Box className="guide-md">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              // Используем Mantine Title для заголовков — единообразный стиль.
              h1: ({ children }) => (
                <Title order={1} mb="md">
                  {children}
                </Title>
              ),
              h2: ({ children }) => (
                <Title order={3} mt="lg" mb="xs">
                  {children}
                </Title>
              ),
              h3: ({ children }) => (
                <Title order={4} mt="md" mb="xs">
                  {children}
                </Title>
              ),
              // Таблицы — с рамками, выглядят как Mantine.
              table: ({ children }) => (
                <table
                  style={{
                    borderCollapse: 'collapse',
                    width: '100%',
                    margin: '1em 0',
                  }}
                >
                  {children}
                </table>
              ),
              th: ({ children }) => (
                <th
                  style={{
                    border: '1px solid #dee2e6',
                    padding: '8px 12px',
                    background: '#f8f9fa',
                    textAlign: 'left',
                  }}
                >
                  {children}
                </th>
              ),
              td: ({ children }) => (
                <td style={{ border: '1px solid #dee2e6', padding: '8px 12px' }}>{children}</td>
              ),
              code: ({ children }) => (
                <code
                  style={{
                    background: '#f1f3f5',
                    padding: '2px 5px',
                    borderRadius: 3,
                    fontSize: '0.9em',
                  }}
                >
                  {children}
                </code>
              ),
            }}
          >
            {md}
          </ReactMarkdown>
        </Box>
      </Paper>
    </Container>
  );
}
